require('./myProfileExtractsMenu.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ components
const ButtonMenu = require('./myProfileExtractsMenuButton.js');

// @ utilites
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ constants
const { DOCUMENTS_GROUPS }  = require('constants/documentsGroups');
const ALL_GROUPS_ITEM = DOCUMENTS_GROUPS[0];

// hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class MyProfileExtractsMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleGroupChange = this.handleGroupChange.bind(this);
    }

    checkFeatureToggling = (item) => {
        const { flagBasedFeatures } = this.props;
        return !item.featureTogglingCheck || (item.featureTogglingCheck && flagBasedFeatures.get(item.featureTogglingCheck));
    }

    checkMBFeatureToggling = (item) => {
        const { flagBasedMBFeatures } = this.props;
        return !item.featureMBTogglingCheck || (item.featureMBTogglingCheck && flagBasedMBFeatures.get(item.featureMBTogglingCheck));
    }

    getMenuList = () => {
        return [ALL_GROUPS_ITEM].concat(DOCUMENTS_GROUPS.slice(1).filter(item => {
            return this.checkFeatureToggling(item) && this.checkMBFeatureToggling(item);
        }).sort((a,b) =>
            formatText(`groupNames-${ a.codGrupo }`).localeCompare(formatText(`groupNames-${ b.codGrupo }`))
        ));
    }

    buildMenuList() {
        const { isInsuranceFlagEnabled } = this.props;
        return this.getMenuList().map((item, index) => {
            const onValueChange = () => {
                this.handleGroupChange(item.codGrupo);
                const [isFiltering, isShowMore, isNavigating] = [false, false, true];
                this.props.requestMoreDocuments(isFiltering, isShowMore, isNavigating);
                scrollToTop();
            };
            const isActive = this.props.groupSelected === item.codGrupo;
            const buttonsMenu = (
                <li className="extracts-menu__li" key={index} >
                    <ButtonMenu
                        onClick={onValueChange}
                        label={formatText(`groupNames-${item.codGrupo}`)}
                        isActive={isActive}
                    />
                </li>
            )
            if (!isInsuranceFlagEnabled) {
                if (item.codGrupo !== '0022') {
                    return buttonsMenu;
                }
            } else {
                return buttonsMenu;
            }
        });
    }

    handleGroupChange(newGroupId) {
        this.props.onGroupChange(newGroupId);
    }

    render() {
        const menuList = this.buildMenuList();
        return (
            <div className="extracts-menu__box-container">
                <div className="extracts-menu__box-header">
                    <OKBoxTitle value={formatText('profileExtracts-extractsGroupTitle')} />
                </div>
                <div className="extracts-menu__list">
                    <ul className="extracts-menu__ul">
                        {menuList}
                    </ul>
                </div>
            </div>
        )
    }
}

MyProfileExtractsMenu.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    flagBasedMBFeatures: PropTypes.object.isRequired,
    onGroupChange: PropTypes.func,
    groupSelected: PropTypes.string,
    requestMoreDocuments: PropTypes.func.isRequired,
    documentsByGroup: PropTypes.object.isRequired,
    isInsuranceFlagEnabled: PropTypes.bool
};

module.exports = withFeatureToggling(MyProfileExtractsMenu);
